import { appConfig } from "../Environments/configs";
import { errorFactory, ErrorHandling } from "./errorHandling";
import AuthService from "../Utils/AuthProvider"
const { apiURL: baseURL } = appConfig;

// Function to extract token!
const getToken = () => {
    return "Bearer " + JSON.parse(localStorage.getItem('authToken'))
}

export const postRequest = async (essentials) => {
    let { endPoint = '', tokenFlag = true, firebase = false, body = {} } = essentials;
    try {
        let token = await AuthService.getToken()
        let result = await fetch(`${baseURL}${endPoint}`,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': tokenFlag && token,
                    firebaseToken: firebase && JSON.parse(localStorage.getItem('firebaseToken'))
                },
                body: JSON.stringify(body)
            });
        return await ErrorHandling(result)
    }

    catch (error) {

        console.log("Error: ", { error })
        return errorFactory(error)
    }

}

export const putRequest = async (essentials) => {

    let { endPoint = '', tokenFlag = true, firebase = false, body = {} } = essentials;

    try {
        let token = await AuthService.getToken();
        let result = await fetch(`${baseURL}${endPoint}`,
            {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': tokenFlag && token
                },
                body: JSON.stringify(body)
            });
        return await ErrorHandling(result)

    }

    catch (error) {

        console.log("Error: ", { error })
        return errorFactory(error)
    }

}
export const getRequest = async (essentials) => {

    let { endPoint = '', tokenFlag = true, firebase = false, body = {} } = essentials;

    try {
        let token = await AuthService.getToken()
        let result = await fetch(`${baseURL}${endPoint}`,
            {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': tokenFlag && token
                },
            });

        return await ErrorHandling(result)

    }

    catch (error) {

        console.log("Error: ", { error })
        return errorFactory(error)

    }

}

export const deleteRequest = async (essentials) => {

    let { endPoint = '', tokenFlag = true, firebase = false, body = {} } = essentials;

    try {
        let token = await AuthService.getToken()

        let result = await fetch(`${baseURL}${endPoint}`,
            {
                method: 'DELETE',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': tokenFlag && token
                },
            });

        return await ErrorHandling(result)

    }

    catch (error) {

        console.log("Error: ", { error })
        return errorFactory(error)

    }
}


export const uploadImage = async (essentials) => {

    let { endPoint = '', tokenFlag = true, firebase = false, body = {} } = essentials;

    try {
        let token = await AuthService.getToken()

        let result = await fetch(`${baseURL}${endPoint}`,
            {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    'Authorization': tokenFlag && token
                },
                body: body
            });
        console.log({ result })
        return result

    }

    catch (error) {

        console.log("Error: ", { error })
        return errorFactory(error)

    }

}
export const setPrimaryKey = async(lineId) => {
    let token = await AuthService.getToken()
    // fetch(`${config.functionsApi}/setPrimaryKey?id=${lineId}`,
    //   {
    //     method: 'get',
    //     headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    //   })
  }
